import { AsyncStorage } from 'react-native';

class StorageManage {
    constructor(project, page) {
        this.nameSpace = [project, page].filter(str => str).join('_');
        this.storageBackend = AsyncStorage;
    }

    /**
     *
     * @param {*} key
     * @param {*} value
     * @param {Object|null} expires 有效期支持day, hour, minute, second, millisecond
     * @param {function} [callback]
     * @example
     * setItem('foo', {bar: 0}, { hour: 2, minute: 30 })
     */
    async setItem(key, value, expires, callback = () => {}) {
        const nameSpacedKey = `${this.nameSpace}_${key}`;
        const now = new Date().getTime();
        let expiredValue;
        let computedExpires;

        if (expires) {
            let {
                day, hour, minute, second, millisecond
            } = expires;

            day = parseInt(day, 10);
            hour = parseInt(hour, 10);
            minute = parseInt(minute, 10);
            second = parseInt(second, 10);
            millisecond = parseInt(millisecond, 10);

            computedExpires = now + millisecond + second * 1000 + minute * 1000 * 60 + hour * 1000 * 60 * 60 + day * 1000 * 60 * 60 * 24;
        } else {
            computedExpires = null;
        }

        try {
            expiredValue = JSON.stringify({
                value,
                expires: computedExpires
            });
        } catch (err) {
            // TODO watcher
            callback(err);
            throw Error('JSON stringify fail');
        }

        this.storageBackend.setItem(nameSpacedKey, expiredValue, callback);
    }

    async getItem(key, callback = () => {}) {
        const nameSpacedKey = `${this.nameSpace}_${key}`;
        const now = new Date().getTime();
        const originValue = await this.storageBackend.getItem(nameSpacedKey, callback);
        let parsedValue;

        // 从来没有存过
        if (originValue === null) {
            return null;
        }

        try {
            parsedValue = JSON.parse(originValue);
        } catch (err) {
            callback(err);
            throw Error('JSON parse fail');
        }

        const { value, expires } = parsedValue;
        // 存了，但是过期了
        if (expires && now > expires) {
            // 清空
            this.removeItem(nameSpacedKey);
            return null;
        }
        // 存了，没有过期，或者是永久存储
        return value;
    }

    async removeItem(key, callback = () => {}) {
        const nameSpacedKey = `${this.nameSpace}_${key}`;

        await this.storageBackend.removeItem(nameSpacedKey, callback);
    }

    async getAllKeys(callback = () => {}) {
        const allKeys = await this.storageBackend.getAllKeys(callback);

        return allKeys.filter(key => key.indexOf(this.nameSpace) > -1);
    }

    async clear(callback = () => {}) {
        await this.storageBackend.multiRemove((await this.getAllKeys()), callback);
    }
}

export default StorageManage;
